import PropTypes from 'prop-types';
import useLocalize from '../../../utils/hooks/useLocalize';
import PencilIcon from './PencilIcon';
import './ScanCard.scss';
import ScanCardActions from './ScanCardActions';
import ScanCardBase from './ScanCardBase';
import ScanCardFields from './ScanCardFields';
import ScanCardTimestamp from './ScanCardTimestamp';

/**
 * ScanCard component that displays user scan details on the desktop scans page.
 *
 * @param {Object} scan - The scan object containing:
 *   - id: unique identifier
 *   - name: scan name (string)
 *   - fields: array of field objects with id and values
 *   - created: ISO timestamp of creation
 *   - updated: ISO timestamp of last update
 * @param {Function} onDetailsClick - Callback when Details link is clicked
 * @param {Function} onDeleteClick - Callback when delete action is selected from the ellipsis menu
 * @returns React component that renders the scan card
 */
const ScanCard = ({
  scan,
  onDetailsClick,
  onDeleteClick,
  onClick,
  active
}) => {
  const translate = useLocalize();

  const handleDetailsClick = () => {
    onDetailsClick?.(scan);
  };

  return (
    <ScanCardBase
      className="desktop-scan-card"
      title={scan.name}
      titleExtra={<PencilIcon />}
      detailsLabel={translate('desktop.scans.more.details')}
      onDetailsClick={handleDetailsClick}
      footerExtra={
        <ScanCardTimestamp created={scan.created} updated={scan.updated} />
      }
      overlay={<ScanCardActions onDeleteClick={onDeleteClick} scan={scan} />}
      active={active}
      onClick={onClick}
    >
      <ScanCardFields fields={scan.fields} />
    </ScanCardBase>
  );
};

ScanCard.propTypes = {
  scan: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        values: PropTypes.arrayOf(PropTypes.string)
      })
    ),
    created: PropTypes.string,
    updated: PropTypes.string
  }).isRequired,
  onDetailsClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onClick: PropTypes.func,
  active: PropTypes.bool
};

export default ScanCard;
